<template>
  <div>
  <div v-if="normalDialpad" class="dialer-container">
      <b-row style="width:100%;margin-right: 0px;margin-left: 0px;">
        <b-col cols="2" style="">
          <vue-country-code
            class="country-select"
            :dropdownOptions="{ disabledDialCode: false }"
            @onSelect="onSelectThirdParty"
            defaultCountry="us"
            :enabledCountryCode="true"
            :disabledFetchingCountry="true"
            :preferredCountries="[]"
            :onlyCountries="dialable_countries"
          >
          </vue-country-code>
        </b-col>
        <b-col cols="8">
          <b-form-input
            class="dial-pad-number"
            v-model="number"
            type="tel"
            placeholder="Enter External number"
          ></b-form-input>
          
        </b-col>
        <b-col cols="1">
          <font-awesome-icon
            class="dialer-call-button "
            icon="phone-alt"
            @click="MakeOutboundCallToExternalNumber()"
            size="lg"
          />
        </b-col>
      </b-row>
    </div>
    <div class="dialer-container">
      <b-row style="width:100%;margin-right: 0px;margin-left: 0px;">
        <b-col cols="2" style="">
          <vue-country-code
            class="country-select"
            :dropdownOptions="{ disabledDialCode: false }"
            @onSelect="onSelectThirdParty"
            defaultCountry="us"
            :enabledCountryCode="true"
            :disabledFetchingCountry="true"
            :preferredCountries="['us', 'gb']"
            :onlyCountries="dialable_countries"
          >
          </vue-country-code>
        </b-col>
        <b-col cols="8">
          <b-form-input
            class="dial-pad-number"
            v-model="number"
            type="tel"
            placeholder="Enter External number"
          ></b-form-input>
          
        </b-col>
        <b-col cols="1">
          <font-awesome-icon
            class="dialer-call-button "
            icon="phone-alt"
            @click="MakeOutboundCallToExternalNumber()"
            size="lg"
          />
        </b-col>
      </b-row>
    </div>
   
 
    <div class="dialpad-button-container">
      <div v-if="number.length>0" class="backspace">
              <font-awesome-icon icon="backspace" @click="removeDigits()" size="md" />
          </div>
     
      <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('1')"
        @mousedown="dialTone(697.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">1</div>
        <div class="dialpad-filler"></div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('2')"
        @mousedown="dialTone(697.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">2</div>
        <div class="dialpad-letters">ABC</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('3')"
        @mousedown="dialTone(697.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">3</div>
        <div class="dialpad-letters">DEF</div>
      </b-button>
    </div>
    <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('4')"
        @mousedown="dialTone(770.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">4</div>
        <div class="dialpad-letters">GHI</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('5')"
        @mousedown="dialTone(770.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">5</div>
        <div class="dialpad-letters">JKL</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('6')"
        @mousedown="dialTone(770.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">6</div>
        <div class="dialpad-letters">MNO</div>
      </b-button>
    </div>
    <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('7')"
        @mousedown="dialTone(852.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">7</div>
        <div class="dialpad-letters">PQRS</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('8')"
        @mousedown="dialTone(852.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">8</div>
        <div class="dialpad-letters">TUV</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('9')"
        @mousedown="dialTone(852.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">9</div>
        <div class="dialpad-letters">WXYZ</div>
      </b-button>
    </div>
    <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('*')"
        @mousedown="dialTone(941.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">*</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('0')"
        @mousedown="dialTone(941.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">0</div>
        <div class="dialpad-letters">+</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('#')"
        @mousedown="dialTone(941.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">#</div>
      </b-button>

      
    </div>

 


    </div>

 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'amazon-connect-streams'
import 'amazon-connect-chatjs'
import { sendDigits } from '../../lib/CallActions'
import {onAddConference } from "./../../lib/CallActions"
import { checkThirdPartyStatus } from "../../lib/ContactRefresh";


export default {
  name: 'Dialpad',
  data() {
    return {
      number: '',
      dialPadToggleStatus: true,
      contextClass: null,
      context: null,
      oscillator1: null,
      oscillator2: null,
      gainNode: null,
      dialedNumber: '',

    }
  },
  created() {},
  mounted() {
    this.contextClass =
      window.AudioContext ||
      window.webkitAudioContext ||
      window.mozAudioContext ||
      window.oAudioContext ||
      window.msAudioContext
    if (this.contextClass) {
      this.context = new this.contextClass()
    }
  },
  methods: {
    onSelectThirdParty({ name, iso2, dialCode }) {
      console.log(name, iso2, dialCode);
      this.$store.dispatch("call/setThirdPartyCountryCode", {
        country: name,
        code: "+" + dialCode,
      })
    },
    keyDial(number) {
      if ((number) => 0 && number <= 9) {
        this.number = this.number + number
        this.$store.dispatch('call/setDialedNumber', this.dialedNumber + number)
      }
    },
    sendDigits(number) {
      sendDigits(number)
    },
    removeDigits(){
      this.number = this.number.slice(0, this.number.length - 1);
      console.log("remove digits",this.number)



    },
    dialTone(freq1, freq2) {
      var vm = this
      vm.oscillator1 = vm.context.createOscillator()
      vm.oscillator1.type = 0
      vm.oscillator1.frequency.value = freq1
      vm.gainNode = vm.context.createGain
        ? vm.context.createGain()
        : vm.context.createGainNode()
      vm.oscillator1.connect(vm.gainNode, 0, 0)
      vm.gainNode.connect(vm.context.destination)
      vm.gainNode.gain.value = 0.1
      vm.oscillator1.start ? vm.oscillator1.start(0) : vm.oscillator1.noteOn(0)
      vm.oscillator2 = vm.context.createOscillator()
      vm.oscillator2.type = 0
      vm.oscillator2.frequency.value = freq2
      vm.gainNode = vm.context.createGain
        ? vm.context.createGain()
        : vm.context.createGainNode()
      vm.oscillator2.connect(vm.gainNode)
      vm.gainNode.connect(vm.context.destination)
      vm.gainNode.gain.value = 0.1
      vm.oscillator2.start ? vm.oscillator2.start(0) : vm.oscillator2.noteOn(0)
      console.log('the dial tone was clicked')
    },
    stop() {
      var vm = this
      vm.oscillator1.disconnect()
      vm.oscillator2.disconnect()
    },
    async MakeOutboundCallToExternalNumber(){
      console.log("MakeOutboundCallToExternalNumber",this.thirdPartyCountryCode.code,this.number);
      var mobileNumberPattern = /^\d{7,12}$/;
      var countryCodePattern = /^\+\d{1,4}/;

      //check if country code exists in the typed number
      if(countryCodePattern.test(this.number)){
        //If present display error, No country code should be added to the number, it should be selected from dropdown
        console.log("COUNTRY CODE IS PRESENT",this.number)
            let postData = {};
            postData.action = "SHOW_NOTIFICATION";
            postData.type = "COUNTRY_CODE_EXISTS";
            parent.postMessage(postData,"*" );
      }else{
            console.log("COUNTRY CODE IS NOT PRESENT",this.number)
            //Check if mobile number is within range
            if(mobileNumberPattern.test(this.number)){
                  console.log("VALID MOBILE NUMBER");
                  var thirdPartyNumber = this.thirdPartyCountryCode.code+this.number
                  await onAddConference('number',thirdPartyNumber);
                  let conferenceStatus = await checkThirdPartyStatus();
                  console.log("this is thirdparty call during external number",conferenceStatus);
                      if (conferenceStatus == "success") {
                        this.$store.dispatch("call/setCallType", "conference");
                        this.$store.dispatch("actions/callSubNavigation", "call");
                        this.$store.dispatch("call/updateThirdPartyCallerName",thirdPartyNumber);
                      }
                }else{
                    let postData = {};
                    postData.action = "SHOW_NOTIFICATION";
                    postData.type = "INAVLID_PHONE_NUMBER";
                    parent.postMessage(postData,"*" );
                  }


  }


  }
},
  computed: {
    ...mapGetters(['dialable_countries', 'dialedNumber', 'homeSubNav','thirdPartyCountryCode',"isConferenceNumberPadUpdated"]),
  },
}

</script>

<style scoped>
.dialpad-container {
  text-align: center;
}

.button-row {
  margin-top: 10px;
}

.dialpad-button {
  width: 23%;
  height: 55px;
  margin-right: 5px;
  margin-left: 5px;
}

.dialpad-number {
  font-size: 15px;
  font-weight: bold;
}

.dialpad-letters {
  font-size: 10px;
  margin-top: 10px;
  color: #ccc5c5;
}

.dialpad-filler {
  visibility: hidden;
}

.btn {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 0.5;
  border-radius: 0.25rem;
}

.dialer-call-button {
  color: rgb(255, 255, 255);
  background: #0f9d58;
  font-size: 35px;
  padding: 10px;
  border-radius: 50%;
}

.dialer-container {
  background-color: #12344d;
  /* background-color: #08255c; */
  display: flex;
  align-items: center;
  height: 56px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 4px 0 rgb(0 0 0 / 10%);
  font-size: 14px;
  color: #fff;
  margin: -10px -10px 5px -10px;
}

.dialpad-button-container {
  margin-top: 60px;
}

.dial-pad-number {
  border: none;
  background: #12344d;
  color: #fff;
  
}

.backspace{
  margin-left: 65%;

}

</style>
